import Container from '../components/Container/Container';

const AccountingList = () => <Container flex children={undefined}></Container>;

export default AccountingList;
